import {jfPublishedModules} from "./jf_published_modules";
import {jfBuildInfoJson} from "./jf_build_info_json";
import {jfEnvironment} from "./jf_environment";
import {jfIssues} from "./jf_issues";
import {jfDiff} from "./jf_diff";
import {jfReleaseHistory} from "./jf_release_history";
import {jfLicenses} from "./jf_licenses";

export default angular.module('buildTabs', [])
        .directive({
            'jfPublishedModules': jfPublishedModules,
            'jfBuildInfoJson': jfBuildInfoJson,
            'jfEnvironment': jfEnvironment,
            'jfIssues': jfIssues,
            'jfDiff': jfDiff,
            'jfReleaseHistory': jfReleaseHistory,
            'jfLicenses': jfLicenses
    });


// WEBPACK FOOTER //
// ./states/builds/build_tabs/build_tabs.module.js